import { stringifyCoords } from '@modules/planner/unit-menu/utils';
import { updateTravelTime } from '@modules/work-order/work-order-api';
import { getDrivingInfo } from '@composite/map/utils/get-driving-info';
import { WorkOrder } from '@models';

export const updateEdgeWorkOrdersTravelTime = async ({
  workOrder,
  nextWorkOrder,
  prevWorkOrder,
}: {
  workOrder: WorkOrder;
  nextWorkOrder?: WorkOrder;
  prevWorkOrder?: WorkOrder;
}) => {
  if (nextWorkOrder && nextWorkOrder?.id !== workOrder.id) {
    const woCoords = stringifyCoords([workOrder, nextWorkOrder]);
    const travelTime = await getDrivingInfo(woCoords);
    const travelPrevious = Math.round(travelTime.duration);
    await updateTravelTime(nextWorkOrder.id, {
      travelNext: nextWorkOrder.travelNext ?? 0,
      travelPrevious,
    }).json();
  }

  if (
    prevWorkOrder &&
    prevWorkOrder?.id !== workOrder.id &&
    Number(prevWorkOrder.travelNext) > 0
  ) {
    await updateTravelTime(prevWorkOrder.id, {
      travelNext: 0,
      travelPrevious: prevWorkOrder.travelPrevious ?? 0,
    }).json();
  }
};
